const searchRules = {
  start_date: ["required", "trim", "string"],
};

export default searchRules;
